import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    rangePicker: null, // 日期范围
    layerList: null, // 选中图层
    renderLayers: null // 渲染图层
}

export const MapSlice = createSlice({
    name: 'MapSlice',
    initialState,
    reducers: {
        changeRangePicker: (state, action) => {
            state.rangePicker = action.payload
        },
        changeLayerList: (state, action) => {
            state.layerList = action.payload
        },
        changeRenderLayers: (state, action) => {
            state.renderLayers = action.payload
        },
    },
})
